import React from "react";
import { PlxsCallout, PlxsText, PlxsHelpLink } from "@plexlogic/plexus-ui";

interface WizardStepQuickCheckProps {
  /** The main text content to display (can also use children for custom content) */
  text?: string | React.ReactNode;
  /** Custom React children (alternative to text prop) */
  children?: React.ReactNode;
  /** Help link URL (optional) */
  helpUrl?: string;
  /** Help link text (default: "check the requirements") */
  helpLinkText?: string;
  /** Additional text after the help link (optional) */
  additionalText?: string;
  /** Custom message (default: "Quick check:") */
  message?: string;
  /** Data test ID for the callout */
  dataTestId?: string;
  /** Data test ID for help link */
  helpLinkDataTestId?: string;
  /** Optional margin bottom style (default: "var(--plexus-space-md)") */
  marginBottom?: string;
}

const WizardStepQuickCheck: React.FC<WizardStepQuickCheckProps> = ({
  text,
  children,
  helpUrl,
  helpLinkText = "check the requirements",
  additionalText,
  message = "Quick check:",
  dataTestId = "wizard-quick-check-callout",
  helpLinkDataTestId = "quick-check-help-link",
  marginBottom = "var(--plexus-space-md)",
}) => {
  // Build supporting copy content
  const getSupportingCopy = () => {
    if (children) {
      return children;
    }
    
    return (
      <PlxsText>
        {text}
        {helpUrl && (
          <>
            <br />
            Please{" "}
            <PlxsHelpLink dataTestId={helpLinkDataTestId} url={helpUrl}>
              {helpLinkText}
            </PlxsHelpLink>
            {additionalText && <>{" "}{additionalText}</>}
          </>
        )}
      </PlxsText>
    );
  };

  return (
    <div style={{ marginBottom }}>
      <PlxsCallout
        tone="brand"
        icon="infoCircle"
        message={message}
        supportingCopy={getSupportingCopy()}
        dataTestId={dataTestId}
      />
    </div>
  );
};

export default WizardStepQuickCheck;
